import React, { Component } from 'react';

//styles
import './sectionFour.scss';

import '../../static/fonts/Rubik/stylesheet.css'
// import { fpInit } from '../../static/player'
import HolaPlayer from '../HolaPlayer/HolaPlayer.jsx'

class SectionFour extends Component {
    componentDidMount() {
        // this.initVideo({
        //     videoId: "1",
        //     mainUrl: "https://mediadownload.ynet.co.il/cdnwiz/1018/041018_ony_with_sub_fix2_cMjs6KB8_1600.mp4",
        //     poster: "./static/images/v1.png",
        //     selector: "#vid1"
        // })        
    }

    // initVideo(details) {
    //     fpInit(details);
    // }

    render() {
        return (
            <div id="section4" className="section4-container">
                {/* <div className="image"></div> */}
                <div className="desc-container">
                    <div className="title">קרוב ושקוף: העוני החדש בישראל</div>
                    <div className="desc">הם נראים כמוני-כמוך, לא מוכרים לרווחה ולא נכנסים לסטטיסטיקה. עובדים, אקדמאים, ממשפחות ממעמד סוציו-אקונומי בינוני, מספרים על העוני כפי שהם חיים אותו</div>
                    <div className="image">
                        <div className="p-container">
                            <HolaPlayer
                                id={"vid1"}
                                poster={"./static/images/v1.png"}
                                src={"https://mediadownload.ynet.co.il/cdnwiz/1018/041018_ony_with_sub_fix2_cMjs6KB8_1600.mp4"} 
                                title={"קרוב ושקוף: העוני החדש בישראל"}/>
                            {/* <video id="vid1" preload="none" class="video-js vjs-default-skin" controls poster="./static/images/v1.png">
                                <source src="https://mediadownload.ynet.co.il/cdnwiz/1018/041018_ony_with_sub_fix2_cMjs6KB8_1600.mp4" />
                            </video> */}
                            <div className="credit-container">
                                <div className="video-credit">
                                    כתבתה של שלומית שרביט ברזילי
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="sub-desc-wrapper">
                        <div className="sub-desc">
                            <b>נועם (40), מורה: </b>
                            &quot;אולי העניין העיקרי הוא, שהיום אני בחור בן 40, משכיל ובעל מקצוע, אני מחשיב את עצמי אדם מוצלח. הוכחתי את עצמי בתחום התעסוקתי. ואני מרוויח לחודש פחות מ-8,000 שקל, שבעיניי זה לא הרבה ולא מספיק לנו! בתחושה שלי, אני רץ כל הזמן אחרי הזנב של עצמי&quot;.
                        </div>
                        <div className="credit">מתוך הספר: "קולות, עוני חדש בישראל" מאת פרופ' עמיה ליבליך</div>
                    </div>
                </div>
                <div className="line"></div>
            </div>
        );
    }
}

export default SectionFour;


// WEBPACK FOOTER //
// ./src/Components/SectionFour/SectionFour.js